import { useGetOntology } from "core/model/utils/ontologies/hooks";
import { VerticalLayout } from "ds_legacy/materials/layouts";
import { margin } from "ds_legacy/materials/metrics";
import { Body } from "ds_legacy/materials/typography";
import { usePrint } from "dsl/atoms/Contexts";
import { EmptiableField } from "dsl/organisms/PatientProfileDetailsShared/shared";
import { useTranslations } from "translations";

const isGrantChecked = (value: number | null | undefined): boolean =>
  (value && value > 0) || false;

export default function ReliefServiceGrant({
  testId,
  value,
}: {
  testId: string;
  value: number | null | undefined;
}) {
  const getOntology = useGetOntology();
  const translations = useTranslations();
  const print = usePrint();

  const title = translations.patient.reliefServices;
  const isChecked = isGrantChecked(value);
  const ontolgyValue = getOntology({ key: value, type: "reliefServices" });

  if (print) {
    return isChecked ? (
      <Body>
        {title}
        {value && `${translations.general.colon} ${ontolgyValue}`}
      </Body>
    ) : null;
  }

  return isChecked ? (
    <VerticalLayout margin={margin(0)}>
      <EmptiableField
        testId={testId}
        title={value ? title : ""}
        value={value ? ontolgyValue : title}
      />
    </VerticalLayout>
  ) : null;
}
